import { pgTable, index, unique, uuid, varchar, timestamp, foreignKey, boolean, text, jsonb, date, integer, pgEnum } from "drizzle-orm/pg-core"
import { sql } from "drizzle-orm"

export const consultationStatus = pgEnum("consultation_status", ['scheduled', 'in_progress', 'completed', 'cancelled'])
export const dataAccessLevel = pgEnum("data_access_level", ['none', 'own', 'tenant', 'role', 'all'])
export const deletionRequestStatus = pgEnum("deletion_request_status", ['pending', 'confirmed', 'completed', 'expired'])
export const ehrIntegrationStatus = pgEnum("ehr_integration_status", ['pending', 'linked', 'failed'])
export const paymentMethodType = pgEnum("payment_method_type", ['debit_order', 'bank_account', 'card'])
export const permissionVerb = pgEnum("permission_verb", ['read', 'create', 'update', 'delete'])
export const staticResource = pgEnum("static_resource", ['public', 'app', 'dashboard', 'error', 'home', 'mobile', 'unauthorized', 'users', 'dashboard.dashboard', 'dashboard.data', 'dashboard.ehr', 'dashboard.patient-profile', 'dashboard.vitals', 'dashboard.waiting-room', 'error.error', 'public.about', 'public.android', 'public.board', 'public.confirm', 'public.delete-data', 'public.doctors', 'public.download', 'public.employers', 'public.privacy', 'public.public', 'public.terms', 'unauthorized.unauthorized', 'users.signin', 'users.signup', 'api/auth/[...nextauth]', 'api/auth/onboarding/start', 'api/auth/signin', 'api/auth/signout', 'api/auth/signup', 'api/contact', 'api/data/delete-request', 'api/data/delete-request/confirm', 'api/data/ehr-integrations', 'api/data/health-record-uploads', 'api/data/home', 'api/data/patient-profiles', 'api/data/patient-profiles/[id]', 'api/data/payment-methods', 'api/data/payment-methods/[id]', 'api/data/payment-methods/[id]/set-default', 'api/data/payment-methods/initialize', 'api/data/payment-methods/verify', 'api/data/permissions', 'api/data/permissions/[id]', 'api/data/roles', 'api/data/roles/[id]', 'api/data/tenants', 'api/data/tenants/[id]', 'api/data/users', 'api/data/users/[id]', 'api/ehr/vitals', 'api/ehr/vitals/submit', 'api/mobile/version-gate', 'api/shenai/token', 'api/webhooks/paystack', 'db_consultation', 'db_datadeletionrequest', 'db_ehrintegration', 'db_healthrecordupload', 'db_patientpaymentmethod', 'db_patientprofile', 'db_role', 'db_roleresourcepermission', 'db_tenant', 'db_tenantuser', 'db_user', 'db_userrole', 'mobile.app.force-update', 'mobile.app.home.index', 'mobile.app.medical-records.index', 'mobile.app.profile.about', 'mobile.app.profile.index', 'mobile.app.profile.patient-details', 'mobile.app.profile.payment-methods', 'mobile.app.users.signin', 'mobile.app.waiting-room', 'mobile.app.waiting-room.active'])


export const dataDeletionRequests = pgTable("DataDeletionRequests", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	externalId: uuid("external_id").defaultRandom().notNull(),
	email: varchar({ length: 64 }).notNull(),
	token: varchar({ length: 128 }).notNull(),
	status: deletionRequestStatus().default('pending').notNull(),
	expiresAt: timestamp("expires_at", { withTimezone: true, mode: 'string' }).notNull(),
	createdAt: timestamp("created_at", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	completedAt: timestamp("completed_at", { withTimezone: true, mode: 'string' }),
}, (table) => [
	index("deletion_request_email_idx").using("btree", table.email.asc().nullsLast().op("text_ops")),
	index("deletion_request_status_idx").using("btree", table.status.asc().nullsLast().op("enum_ops")),
	index("deletion_request_token_idx").using("btree", table.token.asc().nullsLast().op("text_ops")),
	unique("DataDeletionRequests_external_id_unique").on(table.externalId),
	unique("DataDeletionRequests_token_unique").on(table.token),
]);

export const roles = pgTable("Roles", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	externalId: uuid("external_id").defaultRandom().notNull(),
	name: varchar({ length: 64 }).notNull(),
	description: varchar({ length: 256 }),
	tenantId: uuid("tenant_id").notNull(),
	dateCreated: timestamp("date_created", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	dateModified: timestamp("date_modified", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
}, (table) => [
	index("role_external_id_idx").using("btree", table.externalId.asc().nullsLast().op("uuid_ops")),
	index("role_name_idx").using("btree", table.name.asc().nullsLast().op("text_ops")),
	index("role_tenant_id_idx").using("btree", table.tenantId.asc().nullsLast().op("uuid_ops")),
	index("role_tenant_name_idx").using("btree", table.tenantId.asc().nullsLast().op("text_ops"), table.name.asc().nullsLast().op("text_ops")),
	foreignKey({
			columns: [table.tenantId],
			foreignColumns: [tenants.id],
			name: "Roles_tenant_id_Tenants_id_fk"
		}),
	unique("Roles_external_id_unique").on(table.externalId),
]);

export const users = pgTable("Users", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	externalId: uuid("external_id").defaultRandom().notNull(),
	email: varchar({ length: 64 }).notNull(),
	password: varchar({ length: 256 }),
	emailVerified: boolean().notNull(),
	createdAt: timestamp({ withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	updatedAt: timestamp({ withTimezone: true, mode: 'string' }).defaultNow().notNull(),
}, (table) => [
	index("user_external_id_idx").using("btree", table.externalId.asc().nullsLast().op("uuid_ops")),
	unique("Users_external_id_unique").on(table.externalId),
	unique("Users_email_unique").on(table.email),
]);

export const userRoles = pgTable("UserRoles", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	userId: uuid("user_id").notNull(),
	roleId: uuid("role_id").notNull(),
	dateCreated: timestamp("date_created", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
}, (table) => [
	index("user_role_role_id_idx").using("btree", table.roleId.asc().nullsLast().op("uuid_ops")),
	index("user_role_user_id_idx").using("btree", table.userId.asc().nullsLast().op("uuid_ops")),
	index("user_role_user_role_idx").using("btree", table.userId.asc().nullsLast().op("uuid_ops"), table.roleId.asc().nullsLast().op("uuid_ops")),
	foreignKey({
			columns: [table.userId],
			foreignColumns: [users.id],
			name: "UserRoles_user_id_Users_id_fk"
		}),
	foreignKey({
			columns: [table.roleId],
			foreignColumns: [roles.id],
			name: "UserRoles_role_id_Roles_id_fk"
		}),
]);

export const tenants = pgTable("Tenants", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	externalId: uuid("external_id").defaultRandom().notNull(),
	name: varchar({ length: 128 }).notNull(),
	dateCreated: timestamp("date_created", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	dateModified: timestamp("date_modified", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	userId: uuid("user_id").default(sql`'fdaf4e0f-df71-49ce-bcc9-e21e7c3dec11'`).notNull(),
}, (table) => [
	index("tenant_external_id_idx").using("btree", table.externalId.asc().nullsLast().op("uuid_ops")),
	index("tenant_name_idx").using("btree", table.name.asc().nullsLast().op("text_ops")),
	index("tenant_user_id_idx").using("btree", table.userId.asc().nullsLast().op("uuid_ops")),
	foreignKey({
			columns: [table.userId],
			foreignColumns: [users.id],
			name: "Tenants_user_id_Users_id_fk"
		}),
	unique("Tenants_external_id_unique").on(table.externalId),
]);

export const tenantUsers = pgTable("TenantUsers", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	tenantId: uuid("tenant_id").notNull(),
	userId: uuid("user_id").notNull(),
	dateCreated: timestamp("date_created", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
}, (table) => [
	index("tenant_user_tenant_id_idx").using("btree", table.tenantId.asc().nullsLast().op("uuid_ops")),
	index("tenant_user_tenant_user_idx").using("btree", table.tenantId.asc().nullsLast().op("uuid_ops"), table.userId.asc().nullsLast().op("uuid_ops")),
	index("tenant_user_user_id_idx").using("btree", table.userId.asc().nullsLast().op("uuid_ops")),
	foreignKey({
			columns: [table.tenantId],
			foreignColumns: [tenants.id],
			name: "TenantUsers_tenant_id_Tenants_id_fk"
		}),
	foreignKey({
			columns: [table.userId],
			foreignColumns: [users.id],
			name: "TenantUsers_user_id_Users_id_fk"
		}),
	unique("tenant_users_tenant_user_unique").on(table.tenantId, table.userId),
]);

export const ehrIntegrations = pgTable("EHRIntegrations", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	externalId: uuid("external_id").defaultRandom().notNull(),
	patientId: uuid("patient_id").notNull(),
	ehrProvider: text("ehr_provider").notNull(),
	ehrPatientId: text("ehr_patient_id").notNull(),
	ehrInstanceUrl: text("ehr_instance_url").notNull(),
	isActive: boolean("is_active").default(true).notNull(),
	status: ehrIntegrationStatus().default('pending').notNull(),
	connectionMetadata: jsonb("connection_metadata"),
	createdAt: timestamp("created_at", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	updatedAt: timestamp("updated_at", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	ehrPatientUuid: text("ehr_patient_uuid").notNull(),
}, (table) => [
	index("ehr_integrations_ehr_provider_idx").using("btree", table.ehrProvider.asc().nullsLast().op("text_ops")),
	index("ehr_integrations_external_id_idx").using("btree", table.externalId.asc().nullsLast().op("uuid_ops")),
	index("ehr_integrations_patient_id_idx").using("btree", table.patientId.asc().nullsLast().op("uuid_ops")),
	index("ehr_integrations_status_idx").using("btree", table.status.asc().nullsLast().op("enum_ops")),
	foreignKey({
			columns: [table.patientId],
			foreignColumns: [patientProfiles.id],
			name: "EHRIntegrations_patient_id_PatientProfiles_id_fk"
		}).onDelete("cascade"),
	unique("EHRIntegrations_external_id_unique").on(table.externalId),
	unique("EHRIntegrations_ehr_patient_uuid_unique").on(table.ehrPatientUuid),
]);

export const patientPaymentMethods = pgTable("PatientPaymentMethods", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	externalId: uuid("external_id").defaultRandom().notNull(),
	userId: uuid("user_id").notNull(),
	paymentMethodType: paymentMethodType("payment_method_type").notNull(),
	accountHolderName: varchar("account_holder_name", { length: 64 }).notNull(),
	lastFourDigits: varchar("last_four_digits", { length: 4 }).notNull(),
	bankName: varchar("bank_name", { length: 64 }),
	isDefault: boolean("is_default").notNull(),
	dateCreated: timestamp("date_created", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	dateModified: timestamp("date_modified", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	paystackCustomerCode: varchar("paystack_customer_code", { length: 64 }),
	paystackAuthorizationCode: varchar("paystack_authorization_code", { length: 128 }),
	paystackBin: varchar("paystack_bin", { length: 10 }),
	paystackCardType: varchar("paystack_card_type", { length: 32 }),
	paystackBank: varchar("paystack_bank", { length: 64 }),
}, (table) => [
	index("idx_paystack_authorization_code").using("btree", table.paystackAuthorizationCode.asc().nullsLast().op("text_ops")),
	index("idx_paystack_customer_code").using("btree", table.paystackCustomerCode.asc().nullsLast().op("text_ops")),
	index("patient_payment_method_default_idx").using("btree", table.isDefault.asc().nullsLast().op("bool_ops")),
	index("patient_payment_method_external_id_idx").using("btree", table.externalId.asc().nullsLast().op("uuid_ops")),
	index("patient_payment_method_type_idx").using("btree", table.paymentMethodType.asc().nullsLast().op("enum_ops")),
	index("patient_payment_method_user_id_idx").using("btree", table.userId.asc().nullsLast().op("uuid_ops")),
	foreignKey({
			columns: [table.userId],
			foreignColumns: [users.id],
			name: "PatientPaymentMethods_user_id_Users_id_fk"
		}),
	unique("PatientPaymentMethods_external_id_unique").on(table.externalId),
]);

export const patientProfiles = pgTable("PatientProfiles", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	externalId: uuid("external_id").defaultRandom().notNull(),
	userId: uuid("user_id").notNull(),
	firstName: varchar("first_name", { length: 64 }).notNull(),
	lastName: varchar("last_name", { length: 64 }).notNull(),
	dateOfBirth: date("date_of_birth").notNull(),
	sex: varchar({ length: 20 }).notNull(),
	phone: varchar({ length: 20 }).notNull(),
	emergencyContactName: varchar("emergency_contact_name", { length: 64 }).notNull(),
	emergencyContactPhone: varchar("emergency_contact_phone", { length: 20 }).notNull(),
	dateCreated: timestamp("date_created", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	dateModified: timestamp("date_modified", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
}, (table) => [
	index("patient_profile_external_id_idx").using("btree", table.externalId.asc().nullsLast().op("uuid_ops")),
	index("patient_profile_phone_idx").using("btree", table.phone.asc().nullsLast().op("text_ops")),
	index("patient_profile_user_id_idx").using("btree", table.userId.asc().nullsLast().op("uuid_ops")),
	foreignKey({
			columns: [table.userId],
			foreignColumns: [users.id],
			name: "PatientProfiles_user_id_Users_id_fk"
		}),
	unique("PatientProfiles_external_id_unique").on(table.externalId),
]);

export const healthRecordUploads = pgTable("HealthRecordUploads", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	externalId: uuid("external_id").defaultRandom().notNull(),
	patientId: uuid("patient_id").notNull(),
	ehrIntegrationId: uuid("ehr_integration_id").notNull(),
	ehrDocumentId: text("ehr_document_id"),
	documentName: text("document_name").notNull(),
	documentType: text("document_type").notNull(),
	uploadStatus: text("upload_status").notNull(),
	errorMessage: text("error_message"),
	fileSize: integer("file_size"),
	metadata: jsonb(),
	createdAt: timestamp("created_at", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	updatedAt: timestamp("updated_at", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
}, (table) => [
	index("health_record_uploads_created_at_idx").using("btree", table.createdAt.asc().nullsLast().op("timestamptz_ops")),
	index("health_record_uploads_ehr_integration_id_idx").using("btree", table.ehrIntegrationId.asc().nullsLast().op("uuid_ops")),
	index("health_record_uploads_external_id_idx").using("btree", table.externalId.asc().nullsLast().op("uuid_ops")),
	index("health_record_uploads_patient_id_idx").using("btree", table.patientId.asc().nullsLast().op("uuid_ops")),
	index("health_record_uploads_upload_status_idx").using("btree", table.uploadStatus.asc().nullsLast().op("text_ops")),
	foreignKey({
			columns: [table.patientId],
			foreignColumns: [patientProfiles.id],
			name: "HealthRecordUploads_patient_id_PatientProfiles_id_fk"
		}).onDelete("cascade"),
	foreignKey({
			columns: [table.ehrIntegrationId],
			foreignColumns: [ehrIntegrations.id],
			name: "HealthRecordUploads_ehr_integration_id_EHRIntegrations_id_fk"
		}).onDelete("cascade"),
	unique("HealthRecordUploads_external_id_unique").on(table.externalId),
]);

export const consultations = pgTable("Consultations", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	externalId: uuid("external_id").defaultRandom().notNull(),
	userId: uuid("user_id").notNull(),
	ehrConsultationId: varchar("ehr_consultation_id", { length: 64 }),
	status: consultationStatus().notNull(),
	startedAt: timestamp("started_at", { withTimezone: true, mode: 'string' }),
	endedAt: timestamp("ended_at", { withTimezone: true, mode: 'string' }),
	dateCreated: timestamp("date_created", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
	dateModified: timestamp("date_modified", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
}, (table) => [
	index("consultation_ehr_id_idx").using("btree", table.ehrConsultationId.asc().nullsLast().op("text_ops")),
	index("consultation_external_id_idx").using("btree", table.externalId.asc().nullsLast().op("uuid_ops")),
	index("consultation_started_at_idx").using("btree", table.startedAt.asc().nullsLast().op("timestamptz_ops")),
	index("consultation_status_idx").using("btree", table.status.asc().nullsLast().op("enum_ops")),
	index("consultation_user_id_idx").using("btree", table.userId.asc().nullsLast().op("uuid_ops")),
	foreignKey({
			columns: [table.userId],
			foreignColumns: [users.id],
			name: "Consultations_user_id_Users_id_fk"
		}),
	unique("Consultations_external_id_unique").on(table.externalId),
]);

export const roleResourcePermissions = pgTable("RoleResourcePermissions", {
	id: uuid().defaultRandom().primaryKey().notNull(),
	roleId: uuid("role_id").notNull(),
	resource: staticResource().notNull(),
	verb: permissionVerb().notNull(),
	dataAccess: dataAccessLevel("data_access").notNull(),
	targetRoleId: uuid("target_role_id"),
	dateCreated: timestamp("date_created", { withTimezone: true, mode: 'string' }).defaultNow().notNull(),
}, (table) => [
	index("role_resource_permission_data_access_idx").using("btree", table.dataAccess.asc().nullsLast().op("enum_ops")),
	index("role_resource_permission_resource_idx").using("btree", table.resource.asc().nullsLast().op("enum_ops")),
	index("role_resource_permission_role_id_idx").using("btree", table.roleId.asc().nullsLast().op("uuid_ops")),
	index("role_resource_permission_role_resource_verb_idx").using("btree", table.roleId.asc().nullsLast().op("uuid_ops"), table.resource.asc().nullsLast().op("uuid_ops"), table.verb.asc().nullsLast().op("enum_ops")),
	index("role_resource_permission_target_role_id_idx").using("btree", table.targetRoleId.asc().nullsLast().op("uuid_ops")),
	index("role_resource_permission_verb_idx").using("btree", table.verb.asc().nullsLast().op("enum_ops")),
	foreignKey({
			columns: [table.roleId],
			foreignColumns: [roles.id],
			name: "RoleResourcePermissions_role_id_Roles_id_fk"
		}),
	foreignKey({
			columns: [table.targetRoleId],
			foreignColumns: [roles.id],
			name: "RoleResourcePermissions_target_role_id_Roles_id_fk"
		}),
]);
